import modal from './modal'
import download from './download'
import cache from './cache'
import auth from './auth'

export default function installPlugins(app: any): void {
  app.config.globalProperties.$auth = auth
  app.config.globalProperties.$cache = cache
  app.config.globalProperties.$modal = modal
  app.config.globalProperties.$download = download
}
